/**
 * @description this list combines all locales supported either by MMT or by TOS
 * @link https://docs.google.com/spreadsheets/d/1q_VDRoy3bbkEFf9WYNKM7pIogsbTisd3Fpa0ULTIVS8
 */
const translatedLocaleList = [
  {name: 'Acehnese', mmt: 'ace', tos: '', matecat: 'ace-ID'},
  {name: 'Afrikaans', mmt: 'af', tos: 'af-ZA', matecat: 'af-ZA'},
  {name: 'Akan', mmt: 'ak', tos: '', matecat: 'ak-GH'},
  {name: 'Albanian', mmt: 'sq', tos: 'sq-AL', matecat: 'sq-AL'},
  {name: 'Amharic', mmt: 'am', tos: 'am-ET', matecat: 'am-ET'},
  {
    name: 'Antigua and Barbuda Creole English',
    mmt: '',
    tos: 'aig-AG',
    matecat: 'aig-AG',
  },
  {name: 'Arabic', mmt: 'ar', tos: 'ar-SA', matecat: 'ar-SA'},
  {name: 'Arabic Egyptian', mmt: '', tos: 'ar-EG', matecat: 'ar-EG'},
  {name: 'Aragonese', mmt: '', tos: 'an-ES', matecat: 'an-ES'},
  {name: 'Armenian', mmt: 'hy', tos: 'hy-AM', matecat: 'hy-AM'},
  {name: 'Assamese', mmt: 'as', tos: 'as-IN', matecat: 'as-IN'},
  {name: 'Asturian', mmt: 'ast', tos: 'ast-ES', matecat: 'ast-ES'},
  {name: 'Austrian German', mmt: '', tos: 'de-AT', matecat: 'de-AT'},
  {name: 'Awadhi', mmt: 'awa', tos: '', matecat: 'awa-IN'},
  {name: 'Ayacucho Quechua', mmt: 'quy', tos: '', matecat: 'quy-PE'},
  {name: 'Aymara, Central', mmt: 'ayr', tos: '', matecat: ''},
  {name: 'Azerbaijani', mmt: 'az', tos: 'az-AZ', matecat: 'az-AZ'},
  {name: 'Azerbaijani, Northern', mmt: 'azj', tos: '', matecat: ''},
  {name: 'Azerbaijani, Southern', mmt: 'azb', tos: '', matecat: ''},
  {name: 'Bahamas Creole English', mmt: '', tos: 'bah-BS', matecat: 'bah-BS'},
  {name: 'Bajan', mmt: '', tos: 'bjs-BB', matecat: 'bjs-BB'},
  {name: 'Balinese', mmt: 'ban', tos: '', matecat: 'ban-ID'},
  {name: 'Balkan Gipsy', mmt: '', tos: '', matecat: 'rm-RO'},
  {name: 'Bambara', mmt: 'bm', tos: '', matecat: 'bm-ML'},
  {name: 'Banjar', mmt: 'bjn', tos: '', matecat: 'bjn-ID'},
  {name: 'Bashkir', mmt: 'ba', tos: '', matecat: 'ba-RU'},
  {name: 'Basque', mmt: '', tos: 'eu-ES', matecat: 'eu-ES'},
  {name: 'Belarusian', mmt: 'be', tos: '', matecat: 'be-BY'},
  {name: 'Belgian French', mmt: '', tos: 'fr-BE', matecat: 'fr-BE'},
  {name: 'Bemba', mmt: 'bem', tos: 'bem-ZM', matecat: 'bem-ZM'},
  {name: 'Bengali', mmt: 'bn', tos: 'bn-IN', matecat: 'bn-IN'},
  {name: 'Bhojpuri', mmt: 'bho', tos: '', matecat: 'bho-IN'},
  {name: 'Bielarus', mmt: '', tos: 'be-BY', matecat: ''},
  {name: 'Bihari', mmt: '', tos: '', matecat: 'bh-IN'},
  {name: 'Bislama', mmt: '', tos: 'bi-VU', matecat: 'bi-VU'},
  {name: 'Borana', mmt: '', tos: '', matecat: 'gax-KE'},
  {name: 'Bosnian', mmt: 'bs', tos: 'bs-BA', matecat: 'bs-BA'},
  {name: 'Bosnian (Cyrillic)', mmt: '', tos: '', matecat: 'bs-Cyrl-BA'},
  {name: 'Breton', mmt: '', tos: 'br-FR', matecat: 'br-FR'},
  {name: 'Buginese', mmt: 'bug', tos: '', matecat: 'bug-ID'},
  {name: 'Bulgarian', mmt: 'bg', tos: 'bg-BG', matecat: 'bg-BG'},
  {name: 'Burmese', mmt: '', tos: 'my-MM', matecat: 'my-MM'},
  {name: 'Catalan', mmt: 'ca', tos: 'ca-ES', matecat: 'ca-ES'},
  {name: 'Catalan Valencian', mmt: '', tos: 'cav-ES', matecat: 'cav-ES'},
  {name: 'Cebuano', mmt: 'ceb', tos: 'ceb-PH', matecat: 'ceb-PH'},
  {name: 'Central Atlas Tamazight', mmt: '', tos: '', matecat: 'tzm-MA'},
  {name: 'Central Aymara', mmt: '', tos: '', matecat: 'ayr-BO'},
  {name: 'Central Kanuri (Latin script)', mmt: '', tos: '', matecat: 'knc-NG'},
  {name: 'Chadian Arabic', mmt: '', tos: '', matecat: 'shu-TD'},
  {name: 'Chamorro', mmt: '', tos: 'ch-GU', matecat: 'ch-GU'},
  {name: 'Cherokee', mmt: '', tos: 'chr-US', matecat: 'chr-US'},
  {name: 'Chhattisgarhi', mmt: 'hne', tos: '', matecat: 'hne-IN'},
  {name: 'Chinese (Simplified)', mmt: 'zh-CN', tos: 'zh-CN', matecat: 'zh-CN'},
  {name: 'Chinese (Traditional)', mmt: 'zh-TW', tos: 'zh-TW', matecat: 'zh-TW'},
  {name: 'Chinese Trad. (Hong Kong)', mmt: '', tos: 'zh-HK', matecat: 'zh-TW'},
  {name: 'Chinese Traditional Macau', mmt: '', tos: 'zh-MO', matecat: 'zh-MO'},
  {name: 'Chittagonian', mmt: '', tos: '', matecat: 'ctg-BD'},
  {name: 'Chokwe', mmt: 'cjk', tos: '', matecat: 'cjk-AO'},
  {name: 'Chuj', mmt: '', tos: '', matecat: 'cac-GT'},
  {name: 'Classical Greek', mmt: '', tos: 'grc-GR', matecat: 'grc-GR'},
  {name: 'Comorian Ngazidja', mmt: '', tos: 'zdj-KM', matecat: 'zdj-KM'},
  {name: 'Coptic', mmt: '', tos: 'cop-EG', matecat: 'cop-EG'},
  {name: 'Crimean Tatar', mmt: 'crh', tos: '', matecat: 'crh-RU'},
  {name: 'Crioulo Upper Guinea', mmt: '', tos: 'pov-GW', matecat: 'pov-GW'},
  {name: 'Croatian', mmt: 'hr', tos: 'hr-HR', matecat: 'hr-HR'},
  {name: 'Czech', mmt: 'cs', tos: 'cs-CZ', matecat: 'cs-CZ'},
  {name: 'Danish', mmt: 'da', tos: 'da-DK', matecat: 'da-DK'},
  {name: 'Dari', mmt: 'prs', tos: 'prs-AF', matecat: 'prs-AF'},
  {name: 'Dimli', mmt: 'diq', tos: '', matecat: 'diq-TR'},
  {name: 'Dinka, Southwestern', mmt: 'dik', tos: '', matecat: ''},
  {name: 'Dutch', mmt: 'nl', tos: 'nl-NL', matecat: 'nl-NL'},
  {name: 'Dyula', mmt: 'dyu', tos: '', matecat: 'dyu-CI'},
  {name: 'Dzongkha', mmt: 'dz', tos: 'dz-BT', matecat: 'dz-BT'},
  {name: 'Eastern Yiddish', mmt: '', tos: '', matecat: 'ydd-US'},
  {name: 'Emakhuwa', mmt: '', tos: '', matecat: 'vmw-MZ'},
  {name: 'English', mmt: 'en', tos: 'en-GB', matecat: 'en-GB'},
  {name: 'English Australia', mmt: '', tos: 'en-AU', matecat: 'en-AU'},
  {name: 'English Canada', mmt: '', tos: 'en-CA', matecat: 'en-CA'},
  {name: 'English India', mmt: '', tos: '', matecat: 'en-IN'},
  {name: 'English Ireland', mmt: '', tos: 'en-IE', matecat: 'en-IE'},
  {name: 'English New Zealand', mmt: '', tos: 'en-NZ', matecat: 'en-NZ'},
  {name: 'English Singapore', mmt: '', tos: '', matecat: 'en-SG'},
  {name: 'English South Africa', mmt: '', tos: 'en-ZA', matecat: 'en-ZA'},
  {name: 'English US', mmt: '', tos: 'en-US', matecat: 'en-US'},
  {name: 'Esperanto', mmt: 'eo', tos: 'eo-EU', matecat: 'eo-EU'},
  {name: 'Estonian', mmt: 'et', tos: 'et-EE', matecat: 'et-EE'},
  {name: 'Ewe', mmt: 'ee', tos: '', matecat: 'ee-GH'},
  {name: 'Fanagalo', mmt: '', tos: 'fn-FNG', matecat: 'fn-FNG'},
  {name: 'Faroese', mmt: 'fo', tos: 'fo-FO', matecat: 'fo-FO'},
  {name: 'Fijian', mmt: 'fj', tos: 'fj-FJ', matecat: 'fj-FJ'},
  {name: 'Filipino', mmt: '', tos: 'fil-PH', matecat: 'fil-PH'},
  {name: 'Finnish', mmt: 'fi', tos: 'fi-FI', matecat: 'fi-FI'},
  {name: 'Flemish', mmt: '', tos: 'nl-BE', matecat: 'nl-BE'},
  {name: 'Fon', mmt: 'fon', tos: '', matecat: 'fon-BJ'},
  {name: 'French', mmt: 'fr', tos: 'fr-FR', matecat: 'fr-FR'},
  {name: 'French Canada', mmt: '', tos: 'fr-CA', matecat: 'fr-CA'},
  {name: 'French Swiss', mmt: '', tos: 'fr-CH', matecat: 'fr-CH'},
  {name: 'Friulian', mmt: 'fur', tos: '', matecat: 'fur-IT'},
  {name: 'Fula', mmt: '', tos: '', matecat: 'ff-FUL'},
  {name: 'Galician', mmt: 'gl', tos: 'gl-ES', matecat: 'gl-ES'},
  {name: 'Gamargu', mmt: '', tos: '', matecat: 'mfi-NG'},
  {name: 'Ganda', mmt: 'lg', tos: 'lg-UG', matecat: ''},
  {name: 'Garo', mmt: '', tos: '', matecat: 'grt-IN'},
  {name: 'Georgian', mmt: 'ka', tos: 'ka-GE', matecat: 'ka-GE'},
  {name: 'German', mmt: 'de', tos: 'de-DE', matecat: 'de-DE'},
  {name: 'Gilbertese', mmt: '', tos: '', matecat: 'gil-KI'},
  {name: 'Glavda', mmt: '', tos: '', matecat: 'glw-NG'},
  {name: 'Greek', mmt: 'el', tos: 'el-GR', matecat: 'el-GR'},
  {name: 'Grenadian Creole English', mmt: '', tos: 'gcl-GD', matecat: 'gcl-GD'},
  {name: 'Guarani', mmt: 'gn', tos: '', matecat: 'gn-PY'},
  {name: 'Gujarati', mmt: 'gu', tos: 'gu-IN', matecat: 'gu-IN'},
  {name: 'Guyanese Creole English', mmt: '', tos: 'gyn-GY', matecat: 'gyn-GY'},
  {name: 'Haitian Creole French', mmt: 'ht', tos: 'ht-HT', matecat: 'ht-HT'},
  {name: 'Halh Mongolian', mmt: 'khk', tos: '', matecat: 'khk-MN'},
  {name: 'Hausa', mmt: 'ha', tos: 'ha-NE', matecat: 'ha-NE'},
  {name: 'Hawaiian', mmt: '', tos: 'haw-US', matecat: 'haw-US'},
  {name: 'Hebrew', mmt: 'he', tos: 'he-IL', matecat: 'he-IL'},
  {name: 'Higi', mmt: '', tos: '', matecat: 'hig-NG'},
  {name: 'Hiligaynon', mmt: '', tos: 'hil-PH', matecat: 'hil-PH'},
  {name: 'Hill Mari', mmt: '', tos: '', matecat: 'mrj-RU'},
  {name: 'Hindi', mmt: 'hi', tos: 'hi-IN', matecat: 'hi-IN'},
  {name: 'Hmong', mmt: '', tos: '', matecat: 'hmn-CN'},
  {name: 'Hungarian', mmt: 'hu', tos: 'hu-HU', matecat: 'hu-HU'},
  {name: 'Icelandic', mmt: 'is', tos: 'is-IS', matecat: 'is-IS'},
  {name: 'Igbo', mmt: 'ig', tos: 'ibo-NG', matecat: 'ig-NG'},
  {name: 'Ilocano', mmt: 'ilo', tos: 'ilo-PH', matecat: 'ilo-PH'},
  {name: 'Indonesian', mmt: 'id', tos: 'id-ID', matecat: 'id-ID'},
  {name: 'Inuktitut Greenlandic', mmt: '', tos: 'kl-GL', matecat: 'kl-GL'},
  {name: 'Irish', mmt: 'ga', tos: '', matecat: ''},
  {name: 'Irish Gaelic', mmt: '', tos: 'ga-IE', matecat: 'ga-IE'},
  {name: 'Italian', mmt: 'it', tos: 'it-IT', matecat: 'it-IT'},
  {name: 'Italian Swiss', mmt: '', tos: '', matecat: 'it-CH'},
  {name: 'Jamaican Creole English', mmt: '', tos: 'jam-JM', matecat: 'jam-JM'},
  {name: 'Japanese', mmt: 'ja', tos: 'ja-JP', matecat: 'ja-JP'},
  {name: 'Javanese', mmt: 'jv', tos: 'jv-ID', matecat: 'jv-ID'},
  {name: 'Jingpho', mmt: 'kac', tos: '', matecat: 'kac-MM'},
  {name: "K'iche'", mmt: '', tos: '', matecat: 'quc-GT'},
  {name: 'Kabiyè', mmt: 'kbp', tos: '', matecat: 'kbp-TG'},
  {name: 'Kabuverdianu', mmt: 'kea', tos: 'kea-CV', matecat: 'kea-CV'},
  {name: 'Kabylian', mmt: 'kab', tos: 'kab-DZ', matecat: 'kab-DZ'},
  {name: 'Kalenjin', mmt: '', tos: '', matecat: 'kln-KE'},
  {name: 'Kamba', mmt: 'kam', tos: '', matecat: 'kam-KE'},
  {name: 'Kanjobal', mmt: '', tos: '', matecat: 'kjb-GT'},
  {name: 'Kannada', mmt: 'kn', tos: 'kn-IN', matecat: 'kn-IN'},
  {name: 'Kanuri', mmt: '', tos: '', matecat: 'kr-KAU'},
  {name: 'Kanuri, Central (Latin script)', mmt: 'knc', tos: '', matecat: ''},
  {name: 'Karen', mmt: '', tos: '', matecat: 'kar-MM'},
  {name: 'Kashmiri (Arabic script)', mmt: 'kas', tos: '', matecat: 'kas-IN'},
  {name: 'Kashmiri (Devanagari script)', mmt: 'ks', tos: '', matecat: 'ks-IN'},
  {name: 'Kazakh', mmt: 'kk', tos: 'kk-KZ', matecat: 'kk-KZ'},
  {name: 'Khasi', mmt: '', tos: '', matecat: 'kha-IN'},
  {name: 'Khmer', mmt: 'km', tos: 'km-KH', matecat: 'km-KH'},
  {name: 'Kiche', mmt: '', tos: 'quc-GT', matecat: ''},
  {name: 'Kikuyu', mmt: 'ki', tos: '', matecat: 'ki-KE'},
  {name: 'Kimbundu', mmt: 'kmb', tos: '', matecat: 'kmb-AO'},
  {name: 'Kinyarwanda', mmt: 'rw', tos: 'rw-RW', matecat: 'rw-RW'},
  {name: 'Kiribati', mmt: '', tos: 'gil-KI', matecat: ''},
  {name: 'Kirundi', mmt: '', tos: 'rn-BI', matecat: 'rn-BI'},
  {name: 'Kisii', mmt: '', tos: '', matecat: 'guz-KE'},
  {name: 'Klingon', mmt: '', tos: 'tlh-QO', matecat: ''},
  {name: 'Kongo', mmt: 'kg', tos: '', matecat: 'kg-CG'},
  {name: 'Konkani', mmt: '', tos: 'kok-IN', matecat: 'kok-IN'},
  {name: 'Korean', mmt: 'ko', tos: 'ko-KR', matecat: 'ko-KR'},
  {name: 'Kurdish', mmt: '', tos: 'ku-TR', matecat: ''},
  {name: 'Kurdish Sorani', mmt: 'ckb', tos: 'ckb-IQ', matecat: 'ckb-IQ'},
  {name: 'Kurdish, Northern', mmt: 'kmr', tos: '', matecat: ''},
  {name: 'Kyrgyz', mmt: 'ky', tos: 'ky-KG', matecat: 'ky-KG'},
  {name: 'Lao', mmt: 'lo', tos: 'lo-LA', matecat: 'lo-LA'},
  {name: 'Latgalian', mmt: 'ltg', tos: '', matecat: 'ltg-LV'},
  {name: 'Latin', mmt: 'la', tos: 'la-XN', matecat: 'la-XN'},
  {name: 'Latvian', mmt: 'lv', tos: 'lv-LV', matecat: 'lv-LV'},
  {name: 'Ligurian', mmt: 'lij', tos: '', matecat: 'lij-IT'},
  {name: 'Limburgish', mmt: 'li', tos: '', matecat: 'li-NL'},
  {name: 'Lingala', mmt: 'ln', tos: 'ln-LIN', matecat: 'ln-LIN'},
  {name: 'Lithuanian', mmt: 'lt', tos: 'lt-LT', matecat: 'lt-LT'},
  {name: 'Lombard', mmt: 'lmo', tos: '', matecat: 'lmo-IT'},
  {name: 'Luba-Kasai', mmt: 'lua', tos: '', matecat: 'lua-CD'},
  {name: 'Luganda', mmt: '', tos: '', matecat: 'lg-UG'},
  {name: 'Luhya', mmt: '', tos: '', matecat: 'luy-KE'},
  {name: 'Luo', mmt: 'luo', tos: '', matecat: 'luo-KE'},
  {name: 'Luxembourgish', mmt: 'lb', tos: 'lb-LU', matecat: 'lb-LU'},
  {name: 'Maa', mmt: '', tos: '', matecat: 'mas-KE'},
  {name: 'Macedonian', mmt: 'mk', tos: 'mk-MK', matecat: 'mk-MK'},
  {name: 'Magahi', mmt: 'mag', tos: '', matecat: 'mag-IN'},
  {name: 'Maithili', mmt: 'mai', tos: '', matecat: 'mai-IN'},
  {name: 'Malagasy', mmt: 'mg', tos: 'mg-MG', matecat: 'mg-MG'},
  {name: 'Malay', mmt: 'ms', tos: 'ms-MY', matecat: 'ms-MY'},
  {name: 'Malayalam', mmt: 'ml', tos: 'ml-IN', matecat: 'ml-IN'},
  {name: 'Maldivian', mmt: '', tos: 'dv-MV', matecat: 'dv-MV'},
  {name: 'Maltese', mmt: 'mt', tos: 'mt-MT', matecat: 'mt-MT'},
  {name: 'Mam', mmt: '', tos: '', matecat: 'mam-GT'},
  {name: 'Mandara', mmt: '', tos: '', matecat: 'mfi-CM'},
  {name: 'Manipuri', mmt: 'mni', tos: '', matecat: 'mni-IN'},
  {name: 'Manx Gaelic', mmt: '', tos: 'gv-IM', matecat: 'gv-IM'},
  {name: 'Maori', mmt: 'mi', tos: 'mi-NZ', matecat: 'mi-NZ'},
  {name: 'Marathi', mmt: 'mr', tos: 'mr-IN', matecat: 'mr-IN'},
  {name: 'Margi', mmt: '', tos: '', matecat: 'mrt-NG'},
  {name: 'Mari', mmt: '', tos: '', matecat: 'mhr-RU'},
  {name: 'Marshallese', mmt: '', tos: 'mh-MH', matecat: 'mh-MH'},
  {name: 'Mende', mmt: '', tos: 'men-SL', matecat: 'men-SL'},
  {name: 'Meru', mmt: '', tos: '', matecat: 'mer-KE'},
  {name: 'Mijikenda', mmt: '', tos: '', matecat: 'nyf-KE'},
  {name: 'Minangkabau', mmt: 'min', tos: '', matecat: 'min-ID'},
  {name: 'Mizo', mmt: 'lus', tos: '', matecat: 'lus-IN'},
  {name: 'Mongolian', mmt: 'mn', tos: 'mn-MN', matecat: 'mn-MN'},
  {name: 'Montenegrin', mmt: '', tos: 'sr-ME', matecat: 'sr-ME'},
  {name: 'Morisyen', mmt: '', tos: 'mfe-MU', matecat: 'mfe-MU'},
  {name: 'Moroccan Arabic', mmt: '', tos: 'ar-MA', matecat: 'ar-MA'},
  {name: 'Mossi', mmt: 'mos', tos: '', matecat: 'mos-BF'},
  {name: 'Myanmar (Burmese)', mmt: 'my', tos: '', matecat: ''},
  {name: 'Ndau', mmt: '', tos: '', matecat: 'ndc-MZ'},
  {name: 'Ndebele', mmt: '', tos: 'nr-ZA', matecat: 'nr-ZA'},
  {name: 'Nepali', mmt: 'ne', tos: 'ne-NP', matecat: 'ne-NP'},
  {name: 'Nigerian Fulfulde', mmt: 'fuv', tos: '', matecat: 'fuv-NG'},
  {name: 'Niuean', mmt: '', tos: 'niu-NU', matecat: 'niu-NU'},
  {name: 'North Azerbaijani', mmt: '', tos: '', matecat: 'azj-AZ'},
  {name: 'Northern Kurdish', mmt: '', tos: 'kmr-TR', matecat: 'kmr-TR'},
  {name: 'Northern Sotho', mmt: '', tos: 'nso-ZA', matecat: ''},
  {name: 'Northern Uzbek', mmt: '', tos: '', matecat: 'uzn-UZ'},
  {name: 'Norwegian (Nynorsk)', mmt: 'nn', tos: '', matecat: ''},
  {name: 'Norwegian Bokmal', mmt: 'nb', tos: 'nb-NO', matecat: 'nb-NO'},
  {name: 'Norwegian Nynorsk', mmt: '', tos: 'nn-NO', matecat: 'nn-NO'},
  {name: 'Nuer', mmt: 'nus', tos: '', matecat: 'nus-SS'},
  {name: 'Nyanja', mmt: 'ny', tos: 'ny-MW', matecat: 'ny-MW'},
  {name: 'Occitan', mmt: 'oc', tos: 'oc-FR', matecat: 'oc-FR'},
  {name: 'Occitan Aran', mmt: '', tos: 'oc-ES', matecat: 'oc-ES'},
  {name: 'Odia', mmt: 'or', tos: 'or-IN', matecat: 'or-IN'},
  {name: 'Oriya', mmt: '', tos: 'ory-IN', matecat: 'ory-IN'},
  {name: 'Oromo, West Central', mmt: 'gaz', tos: '', matecat: ''},
  {name: 'Palauan', mmt: '', tos: 'pau-PW', matecat: 'pau-PW'},
  {name: 'Pali', mmt: '', tos: '', matecat: 'pi-IN'},
  {name: 'Pangasinan', mmt: 'pag', tos: '', matecat: 'pag-PH'},
  {name: 'Panjabi', mmt: '', tos: 'pa-IN', matecat: ''},
  {name: 'Papiamento', mmt: 'pap', tos: '', matecat: ''},
  {name: 'Papiamentu', mmt: '', tos: 'pap-CW', matecat: 'pap-CW'},
  {name: 'Pashto', mmt: '', tos: 'ps-PK', matecat: 'ps-PK'},
  {name: 'Pashto, Southern', mmt: 'pbt', tos: '', matecat: ''},
  {name: 'Pastho', mmt: 'ps', tos: '', matecat: ''},
  {name: 'Persian', mmt: 'pes', tos: 'fa-IR', matecat: 'fa-IR'},
  {name: 'Pijin', mmt: '', tos: 'pis-SB', matecat: 'pis-SB'},
  {name: 'Plateau Malagasy', mmt: 'plt', tos: '', matecat: 'plt-MG'},
  {name: 'Polish', mmt: 'pl', tos: 'pl-PL', matecat: 'pl-PL'},
  {name: 'Portuguese (Brazil)', mmt: 'pt-BR', tos: 'pt-BR', matecat: 'pt-BR'},
  {name: 'Portuguese (Portugal)', mmt: 'pt-PT', tos: 'pt-PT', matecat: 'pt-BR'},
  {name: 'Potawatomi', mmt: '', tos: 'pot-US', matecat: 'pot-US'},
  {name: 'Punjabi', mmt: 'pa', tos: '', matecat: 'pa-IN'},
  {name: 'Punjabi (Pakistan)', mmt: '', tos: '', matecat: 'pnb-PK'},
  {name: 'Quechua', mmt: '', tos: 'qu-PE', matecat: 'qu-PE'},
  {name: 'Rohingya', mmt: '', tos: '', matecat: 'rhg-MM'},
  {name: 'Rohingyalish', mmt: '', tos: '', matecat: 'rhl-MM'},
  {name: 'Romanian', mmt: 'ro', tos: 'ro-RO', matecat: 'ro-RO'},
  {name: 'Romansh', mmt: '', tos: '', matecat: 'roh-CH'},
  {name: 'Rundi', mmt: 'rn', tos: '', matecat: 'run-BI'},
  {name: 'Russian', mmt: 'ru', tos: 'ru-RU', matecat: 'ru-RU'},
  {
    name: 'Saint Lucian Creole French',
    mmt: '',
    tos: 'acf-LC',
    matecat: 'acf-LC',
  },
  {name: 'Samoan', mmt: 'sm', tos: 'sm-WS', matecat: 'sm-WS'},
  {name: 'Sango', mmt: 'sg', tos: 'sg-CF', matecat: 'sg-CF'},
  {name: 'Sanskrit', mmt: 'sa', tos: '', matecat: 'sa-IN'},
  {name: 'Santali', mmt: 'sat', tos: '', matecat: 'sat-IN'},
  {name: 'Sardinian', mmt: 'sc', tos: '', matecat: 'sc-IT'},
  {name: 'Scots Gaelic', mmt: 'gd', tos: 'gd-GB', matecat: 'gd-GB'},
  {name: 'Sena', mmt: '', tos: '', matecat: 'seh-ZW'},
  {
    name: 'Serbian (Cyrillic)',
    mmt: 'sr-Cyrl',
    tos: 'sr-Cyrl-RS',
    matecat: 'sr-Cyrl-RS',
  },
  {
    name: 'Serbian (Latin)',
    mmt: 'sr-Latn',
    tos: 'sr-Latn-RS',
    matecat: 'sr-Latn-RS',
  },
  {name: 'Serbo-Croatian', mmt: '', tos: 'sh-HR', matecat: ''},
  {name: 'Seselwa Creole French', mmt: '', tos: 'crs-SC', matecat: 'crs-SC'},
  {name: 'Sesotho', mmt: '', tos: 'st-LS', matecat: 'nso-ZA'},
  {name: 'Setswana (South Africa)', mmt: '', tos: 'tn-ZA', matecat: 'tn-ZA'},
  {name: 'Shan', mmt: 'shn', tos: '', matecat: 'shn-MM'},
  {name: 'Shona', mmt: 'sn', tos: 'sn-ZW', matecat: 'sn-ZW'},
  {name: 'Sicilian', mmt: 'scn', tos: '', matecat: 'scn-IT'},
  {name: 'Silesian', mmt: 'szl', tos: '', matecat: 'szl-PL'},
  {name: 'Sindhi', mmt: 'sd', tos: 'snd-PK', matecat: 'sd-PK'},
  {name: 'Sinhala', mmt: 'si', tos: 'si-LK', matecat: 'si-LK'},
  {name: 'Slovak', mmt: 'sk', tos: 'sk-SK', matecat: 'sk-SK'},
  {name: 'Slovenian', mmt: 'sl', tos: 'sl-SI', matecat: 'sl-SI'},
  {name: 'Somali', mmt: 'so', tos: 'so-SO', matecat: 'so-SO'},
  {name: 'Sotho, Northern', mmt: 'nso', tos: '', matecat: ''},
  {name: 'Sotho, Southern', mmt: 'st', tos: '', matecat: 'st-LS'},
  {name: 'South Azerbaijani', mmt: '', tos: '', matecat: 'azb-AZ'},
  {name: 'Southern Pashto', mmt: '', tos: '', matecat: 'pbt-PK'},
  {name: 'Southwestern Dinka', mmt: '', tos: '', matecat: 'dik-SS'},
  {name: 'Spanish', mmt: 'es-ES', tos: 'es-ES', matecat: 'es-ES'},
  {name: 'Spanish Argentina', mmt: '', tos: 'es-AR', matecat: 'es-AR'},
  {name: 'Spanish Colombia', mmt: '', tos: 'es-CO', matecat: 'es-CO'},
  {
    name: 'Spanish Latin America',
    mmt: 'es-419',
    tos: 'es-419',
    matecat: 'es-419',
  },
  {name: 'Spanish Mexico', mmt: '', tos: 'es-MX', matecat: 'es-MX'},
  {name: 'Spanish United States', mmt: '', tos: 'es-US', matecat: 'es-US'},
  {name: 'Sranan Tongo', mmt: '', tos: 'srn-SR', matecat: 'srn-SR'},
  {name: 'Standard Latvian', mmt: 'lvs', tos: '', matecat: 'lvs-LV'},
  {name: 'Standard Malay', mmt: 'zsm', tos: '', matecat: 'zsm-MY'},
  {name: 'Sundanese', mmt: 'su', tos: '', matecat: 'su-ID'},
  {name: 'Swahili', mmt: 'sw', tos: 'sw-KE', matecat: 'sw-KE'},
  {name: 'Swati', mmt: 'ss', tos: '', matecat: 'ss-SZ'},
  {name: 'Swedish', mmt: 'sv', tos: 'sv-SE', matecat: 'sv-SE'},
  {name: 'Swiss German', mmt: '', tos: 'de-CH', matecat: 'de-CH'},
  {name: 'Swiss Italian', mmt: '', tos: 'it-CH', matecat: ''},
  {name: 'Syriac (Aramaic)', mmt: '', tos: 'syc-TR', matecat: 'syc-TR'},
  {name: 'Tagalog', mmt: 'tl', tos: 'tl-PH', matecat: 'tl-PH'},
  {name: 'Tahitian', mmt: '', tos: 'ty-PF', matecat: 'ty-PF'},
  {name: 'Tajik', mmt: 'tg', tos: 'tg-TJ', matecat: 'tg-TJ'},
  {name: 'Tamashek (Tuareg)', mmt: '', tos: 'tmh-DZ', matecat: 'tmh-DZ'},
  {name: 'Tamasheq', mmt: 'taq', tos: '', matecat: 'taq-ML'},
  {name: 'Tamazight, Central Atlas', mmt: 'tzm', tos: '', matecat: ''},
  {name: 'Tamil India', mmt: '', tos: 'ta-IN', matecat: 'ta-IN'},
  {name: 'Tamil Sri Lanka', mmt: 'ta', tos: 'ta-LK', matecat: 'ta-LK'},
  {name: 'Taroko', mmt: '', tos: '', matecat: 'trv-TW'},
  {name: 'Tatar', mmt: 'tt', tos: 'tt-RU', matecat: 'tt-RU'},
  {name: 'Telugu', mmt: 'te', tos: 'te-IN', matecat: 'te-IN'},
  {name: 'Tetum', mmt: '', tos: 'tet-TL', matecat: 'tet-TL'},
  {name: 'Thai', mmt: 'th', tos: 'th-TH', matecat: 'th-TH'},
  {name: 'Tibetan', mmt: 'bo', tos: 'bo-CN', matecat: 'bo-CN'},
  {name: 'Tigrinya', mmt: 'ti', tos: 'ti-ET', matecat: 'ti-ET'},
  {name: 'Tok Pisin', mmt: 'tpi', tos: 'tpi-PG', matecat: 'tpi-PG'},
  {name: 'Tokelauan', mmt: '', tos: 'tkl-TK', matecat: 'tkl-TK'},
  {name: 'Tongan', mmt: '', tos: 'to-TO', matecat: 'to-TO'},
  {name: 'Tosk Albanian', mmt: 'als', tos: '', matecat: 'als-AL'},
  {name: 'Tshiluba', mmt: '', tos: 'lua-CD', matecat: ''},
  {name: 'Tsonga', mmt: 'ts', tos: 'ts-ZA', matecat: 'ts-ZA'},
  {name: 'Tswa', mmt: '', tos: '', matecat: 'tsc-MZ'},
  {name: 'Tswana', mmt: 'tn', tos: 'tn-BW', matecat: 'tn-BW'},
  {name: 'Tumbuka', mmt: 'tum', tos: '', matecat: 'tum-MW'},
  {name: 'Turkish', mmt: 'tr', tos: 'tr-TR', matecat: 'tr-TR'},
  {name: 'Turkmen', mmt: 'tk', tos: 'tk-TM', matecat: 'tk-TM'},
  {name: 'Tuvaluan', mmt: '', tos: 'tvl-TV', matecat: 'tvl-TV'},
  {name: 'Twi', mmt: 'tw', tos: '', matecat: 'tw-GH'},
  {name: 'Udmurt', mmt: '', tos: '', matecat: 'udm-RU'},
  {name: 'Ukrainian', mmt: 'uk', tos: 'uk-UA', matecat: 'uk-UA'},
  {name: 'Uma', mmt: '', tos: 'ppk-ID', matecat: 'ppk-ID'},
  {name: 'Umbundu', mmt: 'umb', tos: '', matecat: 'umb-AO'},
  {name: 'Urdu', mmt: 'ur', tos: 'ur-PK', matecat: 'ur-PK'},
  {name: 'Uyghur', mmt: 'ug', tos: 'uig-CN', matecat: 'ug-CN'},
  {name: 'Uzbek', mmt: '', tos: 'uz-UZ', matecat: 'uz-UZ'},
  {name: 'Uzbek, Northern', mmt: 'uzn', tos: '', matecat: ''},
  {name: 'Venetian', mmt: 'vec', tos: '', matecat: 'vec-IT'},
  {name: 'Vietnamese', mmt: 'vi', tos: 'vi-VN', matecat: 'vi-VN'},
  {
    name: 'Vincentian Creole English',
    mmt: '',
    tos: 'svc-VC',
    matecat: 'svc-VC',
  },
  {
    name: 'Virgin Islands Creole English',
    mmt: '',
    tos: 'vic-US',
    matecat: 'vic-US',
  },
  {name: 'Wallisian', mmt: '', tos: 'wls-WF', matecat: 'wls-WF'},
  {name: 'Waray (Philippines)', mmt: 'war', tos: '', matecat: 'war-PH'},
  {name: 'Welsh', mmt: 'cy', tos: 'cy-GB', matecat: 'cy-GB'},
  {name: 'West Central Oromo', mmt: '', tos: '', matecat: 'gaz-ET'},
  {name: 'Western Persian', mmt: '', tos: '', matecat: 'pes-IR'},
  {name: 'Wolof', mmt: 'wo', tos: 'wo-SN', matecat: 'wo-SN'},
  {name: 'Xhosa', mmt: 'xh', tos: 'xh-ZA', matecat: 'xh-ZA'},
  {name: 'Yiddish', mmt: '', tos: 'yi-YD', matecat: 'yi-YD'},
  {name: 'Yiddish, Eastern', mmt: 'ydd', tos: '', matecat: ''},
  {name: 'Yoruba', mmt: 'yo', tos: 'yo-NG', matecat: 'yo-NG'},
  {name: 'Zulu', mmt: 'zu', tos: 'zu-ZA', matecat: 'zu-ZA'},
]

export const mmtTosLocales = translatedLocaleList.filter(
  (locale) => locale.tos && locale.mmt,
)

export const translateSupportedLanguages = [
  {code: 'ace', name: 'Acehnese'},
  {code: 'af', name: 'Afrikaans'},
  {code: 'ak', name: 'Akan'},
  {code: 'sq', name: 'Albanian'},
  {code: 'am', name: 'Amharic'},
  {code: 'ar', name: 'Arabic'},
  {code: 'hy', name: 'Armenian'},
  {code: 'as', name: 'Assamese'},
  {code: 'ast', name: 'Asturian'},
  {code: 'awa', name: 'Awadhi'},
  {code: 'quy', name: 'Ayacucho Quechua'},
  {code: 'ayr', name: 'Aymara, Central'},
  {code: 'az', name: 'Azerbaijani'},
  {code: 'azj', name: 'Azerbaijani, Northern'},
  {code: 'azb', name: 'Azerbaijani, Southern'},
  {code: 'ban', name: 'Balinese'},
  {code: 'bm', name: 'Bambara'},
  {code: 'bjn', name: 'Banjar'},
  {code: 'ba', name: 'Bashkir'},
  {code: 'be', name: 'Belarusian'},
  {code: 'bem', name: 'Bemba'},
  {code: 'bn', name: 'Bengali'},
  {code: 'bho', name: 'Bhojpuri'},
  {code: 'bs', name: 'Bosnian'},
  {code: 'bug', name: 'Buginese'},
  {code: 'bg', name: 'Bulgarian'},
  {code: 'ca', name: 'Catalan'},
  {code: 'ceb', name: 'Cebuano'},
  {code: 'hne', name: 'Chhattisgarhi'},
  {code: 'zh-CN', name: 'Chinese (Simplified)'},
  {code: 'zh-TW', name: 'Chinese (Traditional)'},
  {code: 'cjk', name: 'Chokwe'},
  {code: 'crh', name: 'Crimean Tatar'},
  {code: 'hr', name: 'Croatian'},
  {code: 'cs', name: 'Czech'},
  {code: 'da', name: 'Danish'},
  {code: 'prs', name: 'Dari'},
  {code: 'diq', name: 'Dimli'},
  {code: 'dik', name: 'Dinka, Southwestern'},
  {code: 'nl', name: 'Dutch'},
  {code: 'dyu', name: 'Dyula'},
  {code: 'dz', name: 'Dzongkha'},
  {code: 'en', name: 'English'},
  {code: 'eo', name: 'Esperanto'},
  {code: 'et', name: 'Estonian'},
  {code: 'ee', name: 'Ewe'},
  {code: 'fo', name: 'Faroese'},
  {code: 'fj', name: 'Fijian'},
  {code: 'fi', name: 'Finnish'},
  {code: 'fon', name: 'Fon'},
  {code: 'fr', name: 'French'},
  {code: 'fur', name: 'Friulian'},
  {code: 'gl', name: 'Galician'},
  {code: 'lg', name: 'Ganda'},
  {code: 'ka', name: 'Georgian'},
  {code: 'de', name: 'German'},
  {code: 'el', name: 'Greek'},
  {code: 'gn', name: 'Guarani'},
  {code: 'gu', name: 'Gujarati'},
  {code: 'ht', name: 'Haitian'},
  {code: 'khk', name: 'Halh Mongolian'},
  {code: 'ha', name: 'Hausa'},
  {code: 'he', name: 'Hebrew'},
  {code: 'hi', name: 'Hindi'},
  {code: 'hu', name: 'Hungarian'},
  {code: 'is', name: 'Icelandic'},
  {code: 'ig', name: 'Igbo'},
  {code: 'ilo', name: 'Iloko'},
  {code: 'id', name: 'Indonesian'},
  {code: 'ga', name: 'Irish'},
  {code: 'it', name: 'Italian'},
  {code: 'ja', name: 'Japanese'},
  {code: 'jv', name: 'Javanese'},
  {code: 'kac', name: 'Jingpho'},
  {code: 'kbp', name: 'Kabiyè'},
  {code: 'kea', name: 'Kabuverdianu'},
  {code: 'kab', name: 'Kabyle'},
  {code: 'kam', name: 'Kamba'},
  {code: 'kn', name: 'Kannada'},
  {code: 'knc', name: 'Kanuri, Central (Latin script)'},
  {code: 'kas', name: 'Kashmiri (Arabic script)'},
  {code: 'ks', name: 'Kashmiri (Devanagari script)'},
  {code: 'kk', name: 'Kazakh'},
  {code: 'km', name: 'Khmer'},
  {code: 'ki', name: 'Kikuyu'},
  {code: 'kmb', name: 'Kimbundu'},
  {code: 'rw', name: 'Kinyarwanda'},
  {code: 'kg', name: 'Kongo'},
  {code: 'ko', name: 'Korean'},
  {code: 'ckb', name: 'Kurdish, Central'},
  {code: 'kmr', name: 'Kurdish, Northern'},
  {code: 'ky', name: 'Kyrgyz'},
  {code: 'lo', name: 'Lao'},
  {code: 'ltg', name: 'Latgalian'},
  {code: 'la', name: 'Latin'},
  {code: 'lv', name: 'Latvian'},
  {code: 'lij', name: 'Ligurian'},
  {code: 'li', name: 'Limburgish'},
  {code: 'ln', name: 'Lingala'},
  {code: 'lt', name: 'Lithuanian'},
  {code: 'lmo', name: 'Lombard'},
  {code: 'lua', name: 'Luba-Kasai'},
  {code: 'luo', name: 'Luo'},
  {code: 'lb', name: 'Luxembourgish'},
  {code: 'mk', name: 'Macedonian'},
  {code: 'mag', name: 'Magahi'},
  {code: 'mai', name: 'Maithili'},
  {code: 'mg', name: 'Malagasy'},
  {code: 'ms', name: 'Malay'},
  {code: 'ml', name: 'Malayalam'},
  {code: 'mt', name: 'Maltese'},
  {code: 'mni', name: 'Manipuri'},
  {code: 'mi', name: 'Maori'},
  {code: 'mr', name: 'Marathi'},
  {code: 'min', name: 'Minangkabau'},
  {code: 'lus', name: 'Mizo'},
  {code: 'mn', name: 'Mongolian (Traditional)'},
  {code: 'mos', name: 'Mossi'},
  {code: 'my', name: 'Myanmar (Burmese)'},
  {code: 'ne', name: 'Nepali'},
  {code: 'fuv', name: 'Nigerian Fulfulde'},
  {code: 'nb', name: 'Norwegian (Bokmål)'},
  {code: 'nn', name: 'Norwegian (Nynorsk)'},
  {code: 'nus', name: 'Nuer'},
  {code: 'ny', name: 'Nyanja'},
  {code: 'oc', name: 'Occitan'},
  {code: 'or', name: 'Odia (Oriya)'},
  {code: 'gaz', name: 'Oromo, West Central'},
  {code: 'pag', name: 'Pangasinan'},
  {code: 'pap', name: 'Papiamento'},
  {code: 'pbt', name: 'Pashto, Southern'},
  {code: 'ps', name: 'Pashto'},
  {code: 'pes', name: 'Persian, Western'},
  {code: 'plt', name: 'Plateau Malagasy'},
  {code: 'pl', name: 'Polish'},
  {code: 'pt-BR', name: 'Portuguese (Brazil)'},
  {code: 'pt-PT', name: 'Portuguese (Portugal)'},
  {code: 'pa', name: 'Punjabi'},
  {code: 'ro', name: 'Romanian'},
  {code: 'rn', name: 'Rundi'},
  {code: 'ru', name: 'Russian'},
  {code: 'sm', name: 'Samoan'},
  {code: 'sg', name: 'Sango'},
  {code: 'sa', name: 'Sanskrit'},
  {code: 'sat', name: 'Santali'},
  {code: 'sc', name: 'Sardinian'},
  {code: 'gd', name: 'Scots Gaelic'},
  {code: 'sr-Cyrl', name: 'Serbian (Cyrillic)'},
  {code: 'sr-Latn', name: 'Serbian (Latin)'},
  {code: 'shn', name: 'Shan'},
  {code: 'sn', name: 'Shona'},
  {code: 'scn', name: 'Sicilian'},
  {code: 'szl', name: 'Silesian'},
  {code: 'sd', name: 'Sindhi'},
  {code: 'si', name: 'Sinhala'},
  {code: 'sk', name: 'Slovak'},
  {code: 'sl', name: 'Slovenian'},
  {code: 'so', name: 'Somali'},
  {code: 'nso', name: 'Sotho, Northern'},
  {code: 'st', name: 'Sotho, Southern'},
  {code: 'es-ES', name: 'Spanish'},
  {code: 'es-419', name: 'Spanish (Latin America)'},
  {code: 'lvs', name: 'Standard Latvian'},
  {code: 'zsm', name: 'Standard Malay'},
  {code: 'su', name: 'Sundanese'},
  {code: 'sw', name: 'Swahili'},
  {code: 'ss', name: 'Swati'},
  {code: 'sv', name: 'Swedish'},
  {code: 'tl', name: 'Tagalog'},
  {code: 'tg', name: 'Tajik'},
  {code: 'taq', name: 'Tamasheq'},
  {code: 'tzm', name: 'Tamazight, Central Atlas'},
  {code: 'ta', name: 'Tamil'},
  {code: 'tt', name: 'Tatar'},
  {code: 'te', name: 'Telugu'},
  {code: 'th', name: 'Thai'},
  {code: 'bo', name: 'Tibetan'},
  {code: 'ti', name: 'Tigrinya'},
  {code: 'tpi', name: 'Tok Pisin'},
  {code: 'als', name: 'Tosk Albanian'},
  {code: 'ts', name: 'Tsonga'},
  {code: 'tn', name: 'Tswana'},
  {code: 'tum', name: 'Tumbuka'},
  {code: 'tr', name: 'Turkish'},
  {code: 'tk', name: 'Turkmen'},
  {code: 'tw', name: 'Twi'},
  {code: 'uk', name: 'Ukrainian'},
  {code: 'umb', name: 'Umbundu'},
  {code: 'ur', name: 'Urdu'},
  {code: 'ug', name: 'Uyghur'},
  {code: 'uzn', name: 'Uzbek, Northern'},
  {code: 'vec', name: 'Venetian'},
  {code: 'vi', name: 'Vietnamese'},
  {code: 'war', name: 'Waray (Philippines)'},
  {code: 'cy', name: 'Welsh'},
  {code: 'wo', name: 'Wolof'},
  {code: 'xh', name: 'Xhosa'},
  {code: 'ydd', name: 'Yiddish, Eastern'},
  {code: 'yo', name: 'Yoruba'},
  {code: 'zu', name: 'Zulu'},
]
